export enum WalletType {
  universal = 0,
  fuel = 2,
  toll = 3,
  communication = 1,
  tontine = 4,
}

export const displayWalletType = (walletType: number) => {
  switch (walletType) {
    case WalletType.universal:
      return "wallet.universalWallet";
    case WalletType.fuel:
      return "wallet.fuel";
    case WalletType.toll:
      return "wallet.toll";
    case WalletType.communication:
      return "wallet.creditCommunication";
    case WalletType.tontine:
      return "wallet.tontine";
  }

  return "";
};
